import React from "react";
import "./CommunityGuidelines.scss"



const CommunityGuidelines = () => (

  <div className="communityguideline-container">
    <h1 className="heading">Community Guidelines</h1>

    <p><strong>Last Updated: 1st May 2025</strong></p>

<p>At Aerial Borne, we are building more than a service platform—we are building a trusted ecosystem of certified drone professionals and customers who value safety, quality, and professionalism.</p>

<p>These Community Guidelines outline the behavior we expect from all users. Following them ensures that our community remains safe, respectful, and efficient.</p>





<h2>1. Professionalism Comes First</h2>
<p>We expect all users—operators and customers alike—to maintain professional conduct at all times.</p>
<ul>
  <li>Be punctual for all engagements</li>
  <li>Communicate clearly and respectfully</li>
  <li>Represent your work or project with integrity</li>
  <li>Honor your commitments and follow through</li>
</ul>



<h2>2. Safety and Compliance Are Non-Negotiable</h2>
<p>We operate in a regulated industry. Every mission must meet required safety standards and comply with DGCA or applicable aviation regulations.</p>
<ul>
  <li>Operators must fly within the legal scope of their licenses</li>
  <li>Customers must provide safe, legal access to job sites</li>
  <li>No mission should compromise airspace safety or endanger others</li>
</ul>



<h2>3. Clear, Honest Communication</h2>
<p>Transparency builds trust. Whether you’re a client posting a project or a drone operator accepting a mission:</p>
<ul>
  <li>Set accurate expectations</li>
  <li>Respond to messages in a timely manner</li>
  <li>Disclose any limitations or concerns up front</li>
  <li>Never withhold critical information related to project scope or location</li>
</ul>


<h2>4. Respect Everyone’s Time</h2>
<p>Time is a professional resource.</p>
<ul>
  <li>Customers should avoid last-minute cancellations unless necessary</li>
  <li>Operators should arrive fully prepared and deliver work on time</li>
  <li>Rescheduling or delays should be communicated promptly and respectfully</li>
</ul>



<h2>5. Zero Tolerance for Misuse or Fraud</h2>
<p>Aerial Borne strictly prohibits:</p>
<ul>
  <li>False identities, licenses, or project claims</li>
  <li>Circumventing the platform to avoid fees or contracts</li>
  <li>Unlawful surveillance, harassment, or privacy violations during drone operations</li>
  <li>Uploading misleading reviews or inaccurate feedback</li>
</ul>
<p>Violations will result in account suspension or permanent removal from the platform.</p>



<h2>6. Fair Dispute Resolution</h2>
<p>We encourage users to resolve issues respectfully and professionally. If a resolution cannot be reached:</p>
<ul>
  <li>Contact Aerial Borne Support</li>
  <li>Provide complete documentation (communications, deliverables, project agreements)</li>
  <li>We will review all sides impartially before offering a resolution</li>
</ul>
<p>Our decisions in mediated cases will be final unless otherwise determined by law.</p>



<h2>7. Contribute to a Safe and Inclusive Space</h2>
<p>We are committed to a platform that is safe and inclusive for all users.</p>
<ul>
  <li>Discrimination, abuse, or harassment will not be tolerated</li>
  <li>Feedback should be constructive and fact-based</li>
  <li>Treat every interaction—online or on-site—with respect and civility</li>
</ul>



<h2>8. Reporting Violations</h2>
<p>If you witness behavior that violates these guidelines, please report it to us immediately at:</p>

<p>📩 Email: <a href="mailto:support@aerialborne.com">support@aerialborne.com</a></p>
<p>📞 Phone: +91-7357017420</p>
<p>📍 Address: <strong>2nd Floor Plot No.4, Minarch Tower Sector-44, Gurgaon, Haryana, India, <a href="https://www.falconebiz.com/company/122003.html" target="_blank">122003</a></strong></p>

<p>Your reports are confidential and will help us maintain the integrity of the platform.</p>



<h2>9. Continuous Improvement</h2>
<p>These guidelines will evolve as our community grows. We will notify users of any significant updates. By continuing to use Aerial Borne, you agree to uphold the latest version of these principles.</p>



<h2>Thank You for Contributing to a Trusted Ecosystem</h2>
<p>Every safe flight, timely delivery, and respectful message builds trust across our network. Whether you're here to fly or to hire, we thank you for helping Aerial Borne stay a reliable, professional space for drone services.</p>











  </div>

);

export default CommunityGuidelines;
